module.exports = __webpack_public_path__ + "img/logo_archives_blue.46dd5e63.png";